<template>
  <v-flex
    xs12
    md10
    offset-md1
    align-self-center
    justify-center
  >
    <v-row>
        <v-col
          cols="3"
        >
          <AutoComplete
          :value="searchEditor"
          v-model="searchEditor"
          key-value="id"
          key-name="name"
          enable-chips
          enable-clearable
          enable-autofocus
          :items="editors"
          :label="$t('fields.editor')"
          @search="searchEditors"
          @input="fetchEditorsIfExist"
          @clear="deleteSelectedEditors"
          :delay="900"
          :errors="errors"
        >
        </AutoComplete>
        </v-col>

        <v-col
          cols="3"
        >
        </v-col>
    </v-row>
    <v-card flat light>
      <v-data-table
        :headers="headers"
        :items="items"
        :server-items-length="totalItems"
        :no-data-text="$t('NO_DATA')"
        :no-results-text="$t('NO_DATA')"
        hide-default-footer
        :options.sync="pagination"
        :loading="loading"
        class="elevation-1"
      >
        <template v-slot:[`item.type`]="{ item }">
            {{ item.type.name}} {{ item.type.grouped}}
        </template>

        <template v-slot:[`item.is_primary`]="{ item }">
           <v-icon
            v-if="item.type.schools_types_options && item.type.schools_types_options.is_primary"
           >done
           </v-icon>
           <v-icon v-else>cancel</v-icon>
        </template>

        <template v-slot:[`item.is_secondary`]="{ item }">
            <v-icon
              v-if="item.type.schools_types_options && item.type.schools_types_options.is_secondary"
            >done
            </v-icon><v-icon v-else>cancel</v-icon>
        </template>

        <template v-slot:[`item.is_elementary`]="{ item }">
            <v-icon
              v-if="item.type.schools_types_options
              && item.type.schools_types_options.is_elementary"
            >done
            </v-icon>
            <v-icon v-else>cancel</v-icon>
        </template>

        <template v-slot:[`item.is_new`]="{ item }">
             {{ item.counter_new}}
        </template>

        <template v-slot:[`item.is_suggested`]="{ item }">
             {{ item.counter_suggested}}
        </template>

        <template v-slot:[`item.city`]="{ item }">
             {{ item.address.city || null}}
        </template>

        <template v-slot:[`item.province`]="{ item }">
             {{ item.address.province_code || null}}
        </template>

        <template v-slot:[`item.code`]="{ item }">
             <span
              v-for="location in item.school_locations_options"
              :key="location.branch_code"
            >
              {{ location.branch_code }}&nbsp;
            </span>
        </template>

      </v-data-table>
      <Paginator
        :total-items="totalItems"
        :page.sync="pagination.page"
        :items-per-page.sync="pagination.itemsPerPage"
        @change="fetchReport"
      />
    </v-card>
  </v-flex>
</template>
<script>

import { adoptionsService } from '../../../utils/services/adoptions.service';
import { editorsService } from '../../../utils/services/editors.service';
import AutoComplete from '../../../components/shared/Inputs/AutoComplete.vue';
import Paginator from '../../../components/shared/Paginator';

export default {
  name: 'AdoptionReportEditorSchool',
  components: { AutoComplete, Paginator },
  data() {
      return {
        loading: false,
        searchEditor: null,
        editor: {},
        editors: [],
        items: [],
        totalItems: 0,
        pagination: {
          page: 1,
          itemsPerPage: 10,
          sortDesc: [false],
          sortBy: ['name'],
        },
        headers: [
          { text: this.$t('fields.code'), value: 'code' },
          { text: this.$t('fields.type'), value: 'type' },
          { text: this.$t('fields.school'), value: 'school_name' },
          { text: this.$t('fields.city'), value: 'city' },
          { text: this.$t('fields.province'), value: 'province' },
          { text: this.$t('fields.is_elementary'), value: 'is_elementary' },
          { text: this.$t('fields.is_primary'), value: 'is_primary' },
          { text: this.$t('fields.is_secondary'), value: 'is_secondary' },
          { text: this.$t('fields.section'), value: 'section' },
          { text: this.$t('fields.is_new'), value: 'is_new' },
          { text: this.$t('fields.capociclo'), value: 'counter_capociclo' },
          { text: this.$t('fields.editor'), value: 'editors.name' },
        ],
        filters: {
          editorId: null,
          searchEditor: null,
        },
      };
    },

    computed: {
      requestFilters() {
        const filters = {
          editorId: this.filters.editorId,
        };

        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }
        return filters;
      },
    },

    methods: {

      resetItems() {
        this.items = [];
        this.totalItems = 0;
        this.pagination.page = 1;
      },

      async searchEditors(val) {
        this.filters.searchEditor = val;
        await this.fetchEditors();
      },

      deleteSelectedEditors() {
        this.editor = {};
        this.filters.editorId = null;
      },

      async fetchEditorsIfExist(id) {
        if (id > 0) {
          this.filters.editorId = id;
          await this.fetchEditor(id);
        } else {
          this.filters.editorId = 0;
        }
      },

      async fetchEditors() {
        return editorsService.index()
        .then(response => {
            this.editors = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },

      async fetchEditor(id) {
        this.loading = true;
        return editorsService.get(id)
        .then(response => {
            this.editor = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        })
        .finally(() => {
            this.loading = false;
        });
      },

      async fetchReport(forcePage) {
        this.loading = true;
        const { page, itemsPerPage } = this.pagination;
        return adoptionsService.reportEditorSchool({
          page: page || forcePage || 1,
          itemsPerPage,
          filters: this.requestFilters,
        },
          )
          .then(response => {
            this.items = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
          })
          .catch(error => {
              this.handleError(error, this.errors);
          }).finally(() => {
            this.loading = false;
          });
      },
    },
    async created() {
      this.fetchReport();
    },
    watch: {
      'filters.editorId': {
        handler() {
          this.resetItems();
          this.fetchReport();
        },
      },
    },
};
</script>
